<template>
    <div class="qrcode" v-if="step == 0">
        <van-form @submit="onSubmit" ref="formRef" class="form-wrapper">
            <van-cell-group inset>
                <van-field
                    v-model="params.userName"
                    label="真实姓名"
                    placeholder="请输入真实姓名"
                    :rules="[{ required: true, message: '请输入真实姓名' }]"
                />
                <van-field
                    v-model="params.idCard"
                    label="身份证号码"
                    placeholder="请输入身份证号码"
                    :rules="[{ required: true, message: '请输入身份证号码' }, { validator: validateIdCard, message: '身份证号码格式错误' }]"
                />
            </van-cell-group>
        </van-form>
        <footer>
            <span class="auth-btn limit plain" @click="emit('prev')">上一步</span>
            <span class="auth-btn limit" @click="createCode">下一步</span>
        </footer>
    </div>
    <div class="qrcode" v-if="step == 1">
        <div>
            <img :src="qrcode">
            <p>打开{{ props.type == 0 ? '支付宝' : '微信' }}扫描二维码进行认证</p>
        </div>
        <footer>
            <span class="auth-btn block" @click="emit('prev')">上一步</span>
        </footer>
    </div>
</template>

<script setup>
import { ref, reactive, toRaw } from 'vue';
import QRCode from 'qrcode'
import { showNotify } from 'vant'
import { http } from '@/request/http'
import { useStore } from 'vuex'

const store = useStore()
const props = defineProps({
    type: Number
})
const emit = defineEmits(['prev', 'next'])
const qrcode = ref('')
const step = ref(0)
const params = reactive({
    userName: '',
    idCard: ''
})

const validateIdCard = (value) => {
    return /^[1-9]\d{16}[\dXx]$/.test(value)
}

const onSubmit = () => {
    createCode()
}

var certifyId, timer
const createCode = () => {
    http.post('/app-api/member/auth/getVerificationUrl', {
        userId: store.state.login.userInfo.id,
        returnUrl: '/',
        ...toRaw(params)
    }).then(res => {
        const certifyUrl = res.certifyUrl
        certifyId = res.certifyId
        QRCode.toDataURL(certifyUrl)
        .then(url => {
            qrcode.value = url
            step.value = 1
            timer = setInterval(getVerificationInfo, 3000)
        })
        .catch(err => {
            showNotify({ type: 'danger', message: '创建二维码失败' })
        })
    })
}

function getVerificationInfo(){
    http.get('/app-api/member/auth/getVerificationInfo?certifyId=' + certifyId).then(res => {
        if(res == 'T'){
            clearInterval(timer)
            showNotify({ type: 'success', message: '认证成功' })
            emit('next')
        }
    })
}
</script>

<style scoped lang="scss">
.auth-btn {
    width: 180rem;
    height: 40rem;
    background: #000;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    &.limit {
        width: 180rem;
    }
    &.plain {
        background-color: #fff;
        color: rgba(0, 0, 0, 1);
    }
    &.block {
        width: 180rem;
        margin: 0 auto;
    }
}
.qrcode {
    width: 100%;
    margin-top: 50rem;
    background-color: #fff;
    padding: 30rem 0;
    .form-wrapper {
        margin-top: 50rem;
    }
    footer {
        display: flex;
        justify-content: space-evenly;
        margin-top: 40rem;
    }
    img {
        width: 200rem;
        height: 200rem;
        display: block;
        margin: 0 auto 20rem;
    }
    p {
        text-align: center;
        color: #666;
    }
}
</style>
